import { createContext, useEffect, useState } from 'react';

export const CartContext = createContext(null);

export const CartProvider = ({ children }) => {
  const [cart, setCart] = useState([]);

  const clearCart = () => setCart([]);

  const addToCart = (newItem) => {
    if (cart.length === 0) {
      newItem.quantity = 1;
      setCart([newItem]);
    }

    const idArray = cart.map((item) => item.id);
    // console.log(idArray);

    if (!idArray.includes(newItem.id)) {
      newItem.quantity = 1;
      setCart([...cart, newItem]);
    } else {
      cart[idArray.indexOf(newItem.id)].quantity++;
      setCart([...cart]);
    }
  };

  const decrementCartItem = (itemToDecrement) => {
    const updatedCart = cart.map((item) => {
      if (itemToDecrement.id === item.id) {
        item.quantity--;
      }

      if (item.quantity !== 0) {
        return item;
      }
    });
    const filteredCart = updatedCart.filter((item) => {
      if (item !== undefined) {
        return item;
      }
    });
    setCart([...filteredCart]);
  };

  const removeFromCart = (i) => {
    cart.splice(i, 1);
    cart.length > 0 ? setCart([...cart]) : setCart([]);
  };

  const cartCount = () => {
    const count = cart.reduce((acc, curr) => {
      return acc + curr.quantity;
    }, 0);
    return count;
  };

  useEffect(() => {
    const isCartActive = JSON.parse(localStorage.getItem('cart'));
    isCartActive?.cart.length > 0 && setCart(isCartActive.cart);
  }, []);

  useEffect(() => {
    localStorage.setItem('cart', JSON.stringify({ cart: [...cart] }));
  }, [cart]);

  return (
    <CartContext.Provider
      value={{
        cart,
        setCart,
        clearCart,
        addToCart,
        removeFromCart,
        cartCount,
        decrementCartItem,
      }}
    >
      {children}
    </CartContext.Provider>
  );
};
